/* eslint-disable react/prop-types */
import React from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  DatePicker,
} from 'antd';
import NumericInput from 'components/NumericInput';

const DatosInformativosIncidencias = ({
  form,
  rules,
  disabled,
  isBlocked,
}) => (
  <Form
    layout="vertical"
    form={form}
    scrollToFirstError
    name="general"
    disabled={disabled}
  >
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="numero_documento"
          label="Número de Documento"
        >
          <Input allowClear disabled={isBlocked} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha"
          label="Fecha del Documento"
        >
          <DatePicker
            placeholder=""
            format="DD/MM/YYYY"
            allowClear
            disabled={isBlocked}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="asunto"
          label="Asunto"
        >
          <Input allowClear disabled={isBlocked} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="otro_dato_1"
          label="Otro Dato 1"
          rules={[{ max: 150, message: 'Máximo 150 caracteres' }]}
        >
          <Input allowClear disabled={isBlocked} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="otro_dato_2"
          label="Otro Dato 2"
          rules={[{ max: 150, message: 'Máximo 150 caracteres' }]}
        >
          <Input allowClear disabled={isBlocked} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="otro_dato_3"
          label="Otro Dato 3"
          rules={[{ max: 150, message: 'Máximo 150 caracteres' }]}
        >
          <Input allowClear disabled={isBlocked} />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item
          name="observaciones"
          label="Observaciones"
          rules={[{
            min: 1,
            max: 500,
            message: 'Debe contener entre 300 y 500 caracteres',
          }]}
        >
          <Input.TextArea
            allowClear
            disabled={isBlocked}
            autoSize={{ minRows: 3, maxRows: 3 }}
          />
        </Form.Item>
      </Col>
    </Row>

  </Form>
);

export default DatosInformativosIncidencias;
